<div class="tenant-debug" [class.is-open]="visible()" role="region" aria-label="Diagnóstico de corporativo">
    @if (visible()) {
        <div class="tenant-debug-panel">
            <header class="tenant-debug-header">
                <mat-icon class="!text-base text-amber-500">bug_report</mat-icon>
                <span class="tenant-debug-title">Diagnóstico de corporativo</span>
                <button mat-icon-button type="button" class="!h-6 !w-6" (click)="toggle()" aria-label="Ocultar diagnóstico">
                    <mat-icon class="!text-base">close</mat-icon>
                </button>
            </header>
            <div class="tenant-debug-body">
                <div class="tenant-debug-row">
                    <span class="tenant-debug-key">Tenants en caché</span>
                    <span class="tenant-debug-val" [class.warn]="tenants().length === 1">
                        {{ tenants().length }}
                    </span>
                </div>
                <div class="tenant-debug-row">
                    <span class="tenant-debug-key">Tenant actual</span>
                    <span class="tenant-debug-val">
                        @if (currentTenant()) {
                            #{{ currentTenant()?.tenantId }} {{ currentTenant()?.tenantName }}
                        } @else {
                            <em class="tenant-debug-empty">— ninguno —</em>
                        }
                    </span>
                </div>
                <div class="tenant-debug-row">
                    <span class="tenant-debug-key">Última llamada</span>
                    <span class="tenant-debug-val" [class.ok]="lastCall()?.ok === true" [class.err]="hasError()">
                        {{ stateLabel() }}
                    </span>
                </div>
                @if (lastCall(); as lc) {
                    <details class="tenant-debug-details">
                        <summary>Detalle de la última llamada</summary>
                        <pre class="tenant-debug-pre">{{ lc.url }}
{{ lc.startedAt }} → {{ lc.finishedAt ?? '—' }}
tenantsReceived: {{ lc.tenantsReceived }}
status: {{ lc.status ?? '—' }}
statusText: {{ lc.statusText ?? '—' }}
@if (lc.errorBody) {
errorBody:
{{ lc.errorBody }}
}</pre>
                    </details>
                }
                @if (tenants().length > 0) {
                    <details class="tenant-debug-details">
                        <summary>Tenants en memoria</summary>
                        <pre class="tenant-debug-pre">{{ tenants() | json }}</pre>
                    </details>
                }
            </div>
            <footer class="tenant-debug-footer">
                <button mat-stroked-button type="button" class="!text-xs" (click)="refresh()">
                    <mat-icon class="!text-sm !mr-1">refresh</mat-icon>
                    Refrescar
                </button>
                <button mat-stroked-button type="button" class="!text-xs" (click)="copyJson()">
                    <mat-icon class="!text-sm !mr-1">content_copy</mat-icon>
                    Copiar JSON
                </button>
                <button mat-stroked-button type="button" class="!text-xs" (click)="goSelectTenant()">
                    <mat-icon class="!text-sm !mr-1">list</mat-icon>
                    Ir a selección
                </button>
                <button mat-flat-button color="warn" type="button" class="!text-xs" (click)="hardReload()">
                    <mat-icon class="!text-sm !mr-1">restart_alt</mat-icon>
                    Reload duro
                </button>
            </footer>
        </div>
    } @else {
        <button mat-icon-button type="button" class="tenant-debug-toggle" (click)="toggle()" aria-label="Abrir diagnóstico de corporativo" [matTooltip]="'Diagnóstico de corporativo'">
            <mat-icon>bug_report</mat-icon>
        </button>
    }
</div>
